import React, { useState } from 'react';
import { Grid, Row, Col, Modal, Thumbnail, ToggleButtonGroup, ToggleButton } from '../ui-kit';
import { chunk } from 'lodash';

const NewDashboardModal = ({ groupDashboardEditRights, setShowNewDashboardModal, templates, createDashboard }) => {
  const defaultType = groupDashboardEditRights ? 'group' : 'personal';
  const [dashboardType, setDashboardType] = useState(defaultType);

  const templateRows = chunk(templates, 3);

  return (
    <Modal size={'xl'} show={true} onHide={() => setShowNewDashboardModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('dashboards.new_dashboard')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ToggleButtonGroup name={'type'} defaultValue={defaultType}>
          <ToggleButton
            disabled={!groupDashboardEditRights}
            value={'group'}
            title={I18n.t('dashboards.types.group.description')}
            onClick={() => setDashboardType('group')}
            variant={dashboardType === 'group' ? 'primary' : 'secondary'}
          >
            {I18n.t('dashboards.types.group.title')}
          </ToggleButton>
          <ToggleButton
            value={'personal'}
            title={I18n.t('dashboards.types.personal.description')}
            onClick={() => setDashboardType('personal')}
            variant={dashboardType === 'group' ? 'secondary' : 'primary'}
          >
            {I18n.t('dashboards.types.personal.title')}
          </ToggleButton>
        </ToggleButtonGroup>
        <br />
        <br />
        <Grid fluid>
          <Row className=" d-flex mb-3">
            <Col className="d-flex p-2" xs={6} md={4}>
              <Thumbnail
                title={I18n.t('dashboards.empty_dashboard')}
                handleClick={() => {
                  createDashboard(dashboardType);
                }}
                style={{ cursor: 'pointer', width: '100%' }}
              />
            </Col>
            <Col md="4" />
            <Col md="4" />
          </Row>
          {templateRows.map((templateRow, index) => (
            <Row key={index} className="mb-3 d-flex flex-fill align-self-stretch">
              {templateRow.map(template => (
                <Col
                  key={template.id}
                  xs={6}
                  md={4}
                  className="p-2 d-flex flex-fill align-self-stretch"
                  style={{ flex: '1' }}
                >
                  <Thumbnail
                    title={template.title}
                    description={template.description}
                    imgSrc={template.photo.url}
                    handleClick={() => {
                      createDashboard(dashboardType, template.id);
                    }}
                    style={{ cursor: 'pointer', width: '100%' }}
                  />
                </Col>
              ))}
              {[...Array.from({ length: 3 - templateRow.length }).keys()].map(i => (
                <Col md="4" key={i} />
              ))}
            </Row>
          ))}
        </Grid>
      </Modal.Body>
    </Modal>
  );
};
export default NewDashboardModal;
